<script setup>
    const props = defineProps({
        data: {
            type: [Object,Array],
            default: {}
        }
    })
    
</script>

<template>
    <div class="nav-list">                     
        <ul>
            <li v-for="(value,index) in props.data.list" :key="index">
                <a-link :to="value.link.path">{{ value.title || '' }}</a-link>
            </li>
        </ul>
    </div>
</template>

<style lang="scss" scoped>
.nav-list {
    width: 1200px;
    height: 50px;
    margin: 0 auto;
    ul {
        display: inline-flex;
        margin-left: 270px;
        li {
            height: 50px;
            line-height: 50px;
            margin-right: 80px;
            font-weight: bold;
            font-size: 18px;
            color: #333;
            &:last-child {
                margin-right: 0;
            }
            a {
                color: #333;
                text-decoration: none;
                font-size: 18px;
                &:hover {
                    color: #dc143c;
                }
            }
        }
    }
}
</style>